import { useTranslation } from 'react-i18next';
import { PageShell } from '@/components/layout';
import {
  GetInTouchSection,
  HeroSection,
  NavigationPill,
  RoadmapSection,
  StorySection,
  TechnologySection,
} from '@/components/home';

export default function Home() {
  const { t } = useTranslation();
  return (
    <PageShell
      title={t('home.meta.title')}
      description={t('home.meta.description')}
      path="/"
      hideHeader
    >
      <NavigationPill />
      <HeroSection />
      <StorySection />
      <TechnologySection />
      <RoadmapSection />
      <GetInTouchSection />
    </PageShell>
  );
}
